import { render, staticRenderFns } from "./liked.vue?vue&type=template&id=ba4fdd08&scoped=true&"
import script from "./liked.vue?vue&type=script&lang=js&"
export * from "./liked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4fdd08",
  null
  
)

export default component.exports